export const MonetizationPatternsHelper = {
  formatTimecode: (seconds: number): string => {
    const totalSeconds = Math.max(0, Math.round(seconds))
    const minutes = Math.floor(totalSeconds / 60)
    const remainingSeconds = totalSeconds % 60

    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
  },
  formatOptionalTimecode: (seconds?: number | null): string =>
    typeof seconds === 'number' ? MonetizationPatternsHelper.formatTimecode(seconds) : '',
  parseTimecode: (value: string): number | undefined => {
    const timecode = value.trim()

    if (timecode.length === 0) return undefined

    if (timecode.includes(':')) {
      const parts = timecode.split(':')

      if (parts.length !== 2 || !parts.every(part => /^\d+$/.test(part))) return undefined

      const [minutes, seconds] = parts.map(part => Number.parseInt(part, 10))
      const totalSeconds = minutes * 60 + seconds

      return seconds < 60 && totalSeconds > 0 ? totalSeconds : undefined
    }

    const minutes = Number.parseFloat(timecode)

    return Number.isNaN(minutes) || minutes <= 0 ? undefined : Math.round(minutes * 60)
  },
  formatFixedMidrolls: (fixedMidrollSeconds: number[]): string =>
    fixedMidrollSeconds
      .map(seconds => MonetizationPatternsHelper.formatTimecode(seconds))
      .join(' · '),
  normaliseFixedMidrolls: (fixedMidrollSeconds: number[]): number[] =>
    Array.from(new Set(fixedMidrollSeconds)).sort((a, b) => a - b),
}
